import CrudService from "@/services/CrudService";
import { IS_LOADING, SET_DATA_ITEM, SET_ERROR, SET_SUCCESS } from "./types";
const crudService = new CrudService();
const findOne = async (store, options) => {
    store.commit(IS_LOADING, true);
    store.commit(SET_SUCCESS, false);
    store.commit(SET_ERROR, null);
    return await crudService
        .findOne(options)
        .then((response) => {
        store.commit(SET_DATA_ITEM, response.data);
        store.commit(SET_SUCCESS, true);
    })
        .catch((error) => {
        store.commit(SET_ERROR, error.response?.data);
    })
        .finally(() => {
        store.commit(IS_LOADING, false);
    });
};
const reset = async (store) => {
    store.commit(IS_LOADING, false);
    store.commit(SET_SUCCESS, false);
    store.commit(SET_ERROR, null);
    store.commit(SET_DATA_ITEM, null);
};
export default {
    findOne,
    reset,
};
